<template>
  <el-popover
    v-model="visible"
    placement="bottom-start"
    :width="210"
    @after-enter="$refs.rangeInputStart.focus()"
    @after-leave="handlePopoverShow"
  >
    <div class="input-range-popover" v-clickoutside="onClickOutside">
      <div class="input-range-main">
        <el-input-number
          style="width: 80px"
          placeholder="开始范围"
          ref="rangeInputStart"
          @focus="handleFocus"
          :controls="false"
          :max="endVal"
          size="mini"
          :precision="2"
          v-model="startVal"
        ></el-input-number>
        <div>-</div>
        <el-input-number
          style="width: 80px"
          placeholder="结束范围"
          @focus="handleFocus"
          :controls="false"
          :min="startVal"
          size="mini"
          :precision="2"
          v-model="endVal"
        ></el-input-number>
      </div>
      <div class="input-range-button-wrapper">
        <div>
          <el-button size="mini" @click="handleReset">清空</el-button>
        </div>
        <div>
          <el-button size="mini" @click="visible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="handleSure"
            >确定</el-button
          >
        </div>
      </div>
    </div>
    <template #reference>
      <el-input
        v-model.trim="currentValue"
        class="ag-table-float-el-input"
        size="mini"
        clearable
        placeholder="范围搜索"
        @input="handleChange"
        @click="visible = true"
        readonly
      >
      </el-input>
    </template>
  </el-popover>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
export default {
  directives: { Clickoutside },
  data () {
    return {
      visible: false,
      currentValue: '',
      startVal: undefined,
      endVal: undefined
    }
  },
  created () {

  },
  methods: {
    handleChange () {
      if (this.currentValue) {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', this.currentValue)
        })
      } else {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', null)
        })
      }
      if (this.params.filterParams.opertype === 3) {
        this.params.enter()
      }
    },
    onParentModelChanged (parentModel, event) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.currentValue = ''
      } else {
        this.currentValue = parentModel.filter
      }
    },
    handleFocus (e) {
      e.target.select()
    },
    handleSure () {
      if ((this.startVal || this.startVal === 0) || (this.endVal || this.endVal === 0)) {
        let x = ''
        let y = ''
        if (this.startVal || this.startVal === 0) {
          x = this.startVal || '0'
        }
        if (this.endVal || this.endVal === 0) {
          y = this.endVal || '0'
        }
        if (x && !y) {
          y = x
        } else if (!x && y) {
          x = y
        }
        this.currentValue = x + ',' + y
      } else {
        this.currentValue = ''
      }
      this.handleChange()
      this.visible = false
    },
    handleReset () {
      this.currentValue = ''
      this.handleChange()
      this.visible = false
    },
    onClickOutside () {
      this.visible = false
    },
    handlePopoverShow () {
      if (this.currentValue) {
        this.startVal = (this.currentValue.split(',')[0] || this.currentValue.split(',')[0] === 0) ? parseFloat(this.currentValue.split(',')[0]) : undefined
        this.endVal = (this.currentValue.split(',')[1] || this.currentValue.split(',')[1] === 0) ? parseFloat(this.currentValue.split(',')[1]) : undefined
      } else {
        this.startVal = undefined
        this.endVal = undefined
      }
    }
  }
}
</script>

<style lang="scss">
.input-range-popover {
  .input-range-main {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .el-input__wrapper {
      padding-left: 5px;
      padding-right: 5px;
    }
    .el-input__inner {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  .input-range-button-wrapper {
    display: flex;
    justify-content: space-between;
  }
}
.ag-table-float-el-input {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);

  .el-input__inner {
    height: 29px;
    border-radius: 0;
    border-color: transparent;
    padding: 1px 7px !important;
    &:focus {
      border-color: #32b16c;
    }
  }
}
</style>
